import(/* webpackMode: "eager" */ "/mnt/volume-nbg1-1/apps/bookie/frontend/src/app/login/page.tsx");
